import * as React from "react";
import "./button.scss";

interface ButtonPropsCommon {
  className?: string;
  text: string;
  buttonType?: "primary" | "secondary" | "error";
  loading?: boolean;
  disabled?: boolean;
}

interface ButtonButtonTagProps extends ButtonPropsCommon {
  onClick: () => void;
}

export interface ButtonATagProps extends ButtonPropsCommon {
  href: string;
  target?: string;
}

type ButtonProps = ButtonATagProps | ButtonButtonTagProps;

export const Button: React.FC<ButtonProps> = (props) => {
  const isDisabled = !!props.disabled || props.loading;

  if ("href" in props && !props.disabled) {
    return (
      <a className={getClassNames(props)} href={props.href} {...(props.target ? { target: props.target } : {})}>
        {props.text}
      </a>
    );
  } else {
    return (
      <button className={getClassNames(props)} onClick={getOnClick(props)} disabled={isDisabled}>
        {props.text}
      </button>
    );
  }
};

function getClassNames(props: ButtonProps): string {
  const buttonClassNames = [];
  if (props.buttonType) {
    buttonClassNames.push(`c-button--${props.buttonType}`);
  }
  if (props.loading) {
    buttonClassNames.push("c-button--loading");
  }
  return `c-button ${props.className} ${buttonClassNames.join(" ")}`;
}

function getOnClick(props: ButtonProps): () => void {
  return "onClick" in props ? props.onClick : () => {};
}

Button.defaultProps = {
  buttonType: "primary",
  className: "",
};
